import React, { useEffect, useState } from "react";
import Modal from 'react-modal';

import modalCustomStyles from '../../util/modalCustomStyles';

const RightModal = ({
  isOpen = true,
  customStyle = {},
  customOverlayStyles = {},
  onRequestClose,
  ...props
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    document.body.style.overflow = 'hidden';

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.style.overflow = 'visible';
    };
  }, []);

  const setModalDimensions = (left = 70, width = 30, small = false) => {
    let top = '0%';
    let height = '100vh';
    if (small) {
      top = 'calc(0% + 60px)';
      height = 'calc(100vh - 140px)';
    }
    const style = {
      top,
      left: `${left}%`,
      width: `${width}%`,
      height,
      marginLeft: '0%',
      transform: 'translate(0%, 0%)',
      borderRadius: 0
    };

    return { ...style, ...customStyle };
  };

  const myCustomStyles = () => {
    if (windowWidth >= 180 && windowWidth <= 575) {
      return setModalDimensions(10, 90, true);
    }

    if (windowWidth >= 576 && windowWidth <= 768) {
      return setModalDimensions(30, 70);
    }

    if (windowWidth > 769 && windowWidth <= 1024) {
      return setModalDimensions(40, 60);
    }

    if (windowWidth > 1025 && windowWidth <= 1300) {
      return setModalDimensions(50, 50);
    }

    if (windowWidth > 1301 && windowWidth <= 1600) {
      return setModalDimensions(60, 40);
    }

    return setModalDimensions();
  };

  return (
    <Modal
      isOpen={isOpen}
      style={modalCustomStyles(false, myCustomStyles(), customOverlayStyles)}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={!!onRequestClose}
    >
      {props.children}
    </Modal>
  );
};

export default RightModal;
